import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarKendalaTeknis from "../../components/TopBarKendalaTeknis";
import LaporanKendalaTeknisAdmin from "../../components/LaporanKendalaTeknisAdmin";
import "../../CSS/LaporKendalaTenagaKesehatan.css"; 

function HalamanLaporanKendalaTeknisAdmin() {
  return (
    <div className="laporkan-page">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarKendalaTeknis />

        {/* Konten utama */}
        <div className="main-content">
          <LaporanKendalaTeknisAdmin />
        </div>

        
      </div>
    </div>
  );
}

export default HalamanLaporanKendalaTeknisAdmin;
